import type { IExtractParams } from "@/routes";
import { apiPathFunc } from "@api/util/apiPathFunc";

const pathBase = `/exams/`;

export type IPathBaseParam = IExtractParams<typeof pathBase>;

export const exams = {
  getAll: apiPathFunc(pathBase),
} as const;
